import { uniq, intersection } from 'lodash-es';

export function mergeLists(list1 = [], list2 = []) {
  return uniq([...list1, ...list2]);
}

export function mergeObjects(state, payload) {
  if (!state) {
    return payload;
  }
  const result = { ...state, ...payload };
  const common = intersection(Object.keys(state), Object.keys(payload));
  common.forEach((key) => {
    if (key === 'list' || (Array.isArray(state[key]) && Array.isArray(payload[key]))) {
      result[key] = mergeLists(state[key], payload[key]);
      return;
    }
    if (state[key] !== null && typeof state[key] === 'object' && typeof payload[key] === 'object') {
      result[key] = { ...state[key], ...payload[key] };
    }
  });
  return result;
}

export function addItem(item, prepend = false) {
  return (obj = { list: [] }) => {
    const { list } = obj;
    const { id } = item;
    function combinedList() {
      return prepend ? [id, ...list] : [...list, id];
    }
    return {
      ...obj,
      [id]: item,
      list: list.includes(id) ? list : combinedList(),
    };
  };
}

export function deleteItem(id, obj) {
  if (!obj) {
    return (o) => deleteItem(id, o);
  }
  const { list } = obj;
  const result = { ...obj, list: list.filter((i) => i !== id) };
  delete result[id];
  return result;
}
